module.exports = __webpack_public_path__ + "static/media/readLater.d8433666.svg";